import { Button, Dialog, DialogBody, DialogFooter, Text } from '@bitrise/bitkit';
import AppForAppPage from '@/pages/App/types/AppForAppPage';
import useDeleteScheduledBuild from './hooks/useDeleteScheduledBuild';

type DialogProps = {
  isOpen: boolean;
  onClose: () => void;
  scheduledBuildItemId: string;
  app: AppForAppPage;
};

const DeleteScheduledBuildDialog = (props: DialogProps) => {
  const { isOpen, onClose, scheduledBuildItemId, app } = props;

  const { mutate: deleteScheduledBuild, isPending } = useDeleteScheduledBuild({
    id: scheduledBuildItemId,
    app,
  });

  const handleDelete = () => {
    deleteScheduledBuild({});
    onClose();
  };

  return (
    <Dialog isOpen={isOpen} onClose={onClose} title="Delete scheduler?">
      <DialogBody>
        <Text>Are you sure you want to delete this scheduler?</Text>
      </DialogBody>
      <DialogFooter>
        <Button onClick={onClose} variant="secondary">
          Cancel
        </Button>
        <Button isDanger onClick={handleDelete} isLoading={isPending}>
          Delete
        </Button>
      </DialogFooter>
    </Dialog>
  );
};

export default DeleteScheduledBuildDialog;
